
const initialState ={
  rerender:0
}

const reducer = (state = initialState, action) => {
  let newState= {...state};
  switch(action.type){
    case "REQUEST_CREATE_SAVED_FILTER_SUCCESS":
    case 'REQUEST_UPDATE_SAVED_FILTER_SUCCESS':
      if(newState.data==undefined){newState.data=[]}
      let done=false; let sfs=[]; for(let sf of newState.data){if(sf.id==action.val.id){done=true; sfs.push(action.val);}else{sfs.push(sf);}}
      if(done==false){sfs.push(action.val);}
      newState.data=sfs;
      if(action.type=='REQUEST_CREATE_SAVED_FILTER_SUCCESS'){window.location.href=action.val.path;}
      newState.rerender=newState.rerender+1;
    break;
    case "REQUEST_INDEX_SAVED_FILTERS_SUCCESS":
      if(newState.data==undefined && window.location.href=='https://app.prospectsafari.com/companies/table'){
        for(let v of action.val){if(v.id==3794){window.location.href=v.path;}}
      }
      newState.data=action.val;
      newState.rerender=newState.rerender+1;
    case "REQUEST_CREATE_TABLE_COLUMN_ORDER_SUCCESS":
    case 'REQUEST_UPDATE_TABLE_COLUMN_ORDER_SUCCESS':
      if (newState.table_column_orders == undefined) { newState.table_column_orders = [] }
      let done_tco = false; let tco = []; for (let sf of newState.table_column_orders) { if (sf.id == action.val.id) { done_tco = true; tco.push(action.val); } else { tco.push(sf); } }
      if (done_tco == false) { tco.push(action.val); }
      newState.table_column_orders = tco;
      newState.rerender = newState.rerender + 1;
      break;
    case "REQUEST_INDEX_TABLE_COLUMN_ORDERS_SUCCESS":
      newState.table_column_orders = action.val;
      newState.rerender = newState.rTABLE_COLUMN_ORDER
    }
  return newState;
}

export default reducer;
